module.exports = __webpack_public_path__ + "static/img/model_tongshuai.8bb1ba6a.jpg";